import { render } from "./notice-dropdown.vue?vue&type=template&id=790fd2da&scoped=true&ts=true"
import script from "./notice-dropdown.vue?vue&type=script&lang=ts"
export * from "./notice-dropdown.vue?vue&type=script&lang=ts"

import "./notice-dropdown.vue?vue&type=style&index=0&id=790fd2da&lang=less&scoped=true"
import "./notice-dropdown.vue?vue&type=style&index=1&id=790fd2da&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790fd2da"]])

export default __exports__